import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './nav-link.scss';

class NavLink extends React.PureComponent {
    getClassNames() {
        let classNames = 'sten-nav-link';
        if (this.props.isActive) {
            classNames += ' sten-nav-link--active';
        }
        if (this.props.className) {
            classNames += ` ${this.props.className}`;
        }
        return classNames;
    }

    render() {
        const iconClassNames = `sten-nav-link__icon icon icon-${this.props.icon}`;
        if (this.props.hasContentLink) {
            return (
                <div className={this.getClassNames()} title={this.props.tooltipTitle} onClick={this.props.onClick}>
                    {this.props.icon && (
                        <span className={iconClassNames} onClick={this.props.onClick} />
                    )}
                    {this.props.children && (
                        <a
                            tabIndex="-1"
                            className="sten-nav-link__content"
                            href={this.props.to}
                            onClick={this.props.onClick}
                        >
                            {this.props.children}
                        </a>
                    )}
                </div>
            );
        }
        if (this.props.to) {
            return (
                <a
                    className={this.getClassNames()}
                    href={this.props.to}
                    onClick={this.props.onClick}
                    title={this.props.tooltipTitle}
                >
                    {this.props.icon && (
                        <span className={iconClassNames} />
                    )}
                    {this.props.children && (
                        <span className="sten-nav-link__content">
                            {this.props.children}
                        </span>
                    )}
                </a>
            );
        }
        return (
            <button className={this.getClassNames()} onClick={this.props.onClick} title={this.props.tooltipTitle}>
                {this.props.icon && (
                    <span className={iconClassNames} />
                )}
                {this.props.children && (
                    <span className="sten-nav-link__content">{this.props.children}</span>
                )}
            </button>
        );
    }
}

NavLink.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    hasContentLink: PropTypes.bool,
    icon: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    to: PropTypes.string,
    tooltipTitle: PropTypes.string
};

NavLink.defaultProps = {
    children: null,
    className: '',
    hasContentLink: false,
    icon: '',
    isActive: false,
    tooltipTitle: '',
    to: ''
};

export default NavLink;
